export default __webpack_public_path__ + "static/media/suda.e9654fb9.jpg";